<bwh-lib-step-control-bar
  [langDropdown]="true"
  [prevBut]="prevBut"
  [closeBut]="closeBut"
  [currentStep]="wizardService?.currentStep"
  [previousStep]="wizardService?.previousStep"
  [steps]="wizardService?.totalSteps"
  (emitClose)="close()"
  (emitPrev)="goPrev()"
>
</bwh-lib-step-control-bar>

<div class="skills-summary text-center">
  <div class="main-header">
    <h1 class="main-title">{{ 'global.summary_title' | translate }}</h1>
    <p class="main-description">{{ 'global.summary_description' | translate }}</p>
  </div>

  <div class="scrollable-content">
    <div *ngIf="dataLoaded" class="your-skills-card">
      <strong class="your-skills-card__label">{{ 'global.your_skills' | translate }}</strong>
      <div class="your-skills-card__pills">
        <div *ngFor="let cat of categories" class="skill-pill-wrapper">
          <button
            class="skill-pill"
            [class.skill-pill--accent]="cat.accent"
            [class.skill-pill--expanded]="cat.expanded"
            (click)="toggleCategory(cat)"
            [attr.aria-expanded]="cat.expanded"
          >
            {{ cat.labelKey | translate }} &middot; {{ cat.count }}
          </button>
          <div *ngIf="cat.expanded && cat.items.length > 0" class="skill-popover">
            <strong class="skill-popover__title">{{ cat.labelKey | translate }}</strong>
            <div class="skill-popover__chips">
              <span *ngFor="let skill of cat.items" class="skill-chip">
                {{ skill.skill_name }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

  <ul class="next-button-container">
    <li *ngIf="prevBut">
      <button class="btn w-md h-lg primary prev-btn" type="button" (click)="goPrev()">
        {{ 'global.previous' | translate }}
      </button>
    </li>
  </ul>
</div>
